import { getCannotAccessList } from "@/router/src/access"
import Validate from "@/prototype/src/validate";

export default {
    install(Vue, option) {
        const cannotAccessList = getCannotAccessList(option.config);
        Vue.prototype.$validate = new (function () {
            this.DataValid = Validate.DataValid;

            const regex = {
                email: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                // phone: /^[2-9][0-9]{7}$/,
                phone: /^(\+?)[0-9]{2,18}$/i,
                hkMobile: /^[3-9][0-9]{7}$/,
                number: /^[0-9]+$/i,
                // floating: /^[0-9]+([.]?[0-9]{1,2})?$/i,
                floating: /^[0-9]+([.]?[0-9]{1})?$/i,
                floatingWithoutLimit: /^[0-9]+([.]?[0-9]+)?$/i,
                negativeNumber: /^[-]?[0-9]+$/i,
                negativeFloating: /^[-]?[0-9]+([.]?[0-9]+)?$/i,
                // blogSlug: /^[a-zA-Z0-9-_]+$/i
                blogSlug: /^[\u4e00-\u9fff\u3400-\u4dff\uf900-\ufaffA-za-z0-9-_]+$/i,
                hkid4Letter: /^[a-zA-Z]{1,2}[0-9]{2,3}$/,
                date: /^\d{4}-\d{2}-\d{2}$/, // YYYY-MM-DD
                dateSlash: /^\d{4}\/\d{2}\/\d{2}$/, // YYYY/MM/DD
                yearMonth: /^\d{4}-\d{2}(-\d{2})?$/, // YYYY-MM
                regexIdNum: /^[a-zA-Z0-9]{8,9}$/i,
                hkPhone: /^(^[2|3|4|5|6|7|8|9])+([0-9]{7})$/,
                twPhone: /^(^[1-9])+([0-9]{8})$/,
                macauPhone: /^([0-9]{8})$/,
                chinaPhone: /^(^[1])+([0-9]{10})$/,
                chinName: /^[\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u017F\u3400-\u4DBF\u4E00-\u9FFF]{2,40}$/,
                engName: /^[a-zA-Z\s.,]{2,40}$/,
                password: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
                idFormat: /^#[0-9]+$/i,
                time: /^\d{2}:\d{2}$/, // 00:00
            }

            const check = (value, name, allowEmpty = false) => {
                if (!Validate.DataValid(value)) {
                    return allowEmpty || 'message.formRequired';
                }

                return this.regex(name, value);
            }

            this.regex = (name, value) => {
                if (name && regex[name]) {
                    return regex[name].test(value);
                }

                return true;
            }

            this.required = value => {
                return Validate.DataValid(value);
            }
            this.regexNumber = (value) => {
                return regex.number.test(value);
            }
            this.regexFloating = (value) => {
                return regex.floatingWithoutLimit.test(value);
            }
            this.regexDateStr = (value) => {
                const valid = regex.date.test(value);
                const validSlash = regex.dateSlash.test(value);
                if (!valid && !validSlash) return false;

                const year = parseInt(value.substring(0, 4));
                const month = parseInt(value.substring(5, 7));
                const date = parseInt(value.substring(8, 10));

                const d = new Date(year, (month - 1), date);
                return d.getFullYear() === year && d.getMonth() === month - 1 && d.getDate() === date;
            }
            this.regexYearMonth = (value) => {
                const valid = regex.yearMonth.test(value);
                if (!valid) return false;

                const month = parseInt(value.substring(5, 7));
                return month > 0 && month <= 12
            }
            this.regexId = (value) => {
                return regex.idFormat.test(value)
            }

            this.isNumber = (value, allowEmpty = false) => {
                const valid = check(value, 'number', allowEmpty);
                return valid || 'message.pleaseEnterValidNumber';
            }
            this.isFloating = (value, allowEmpty = false) => {
                const valid = check(value, 'floatingWithoutLimit', allowEmpty);
                return valid || 'message.pleaseEnterValidNumber';
            }
            this.isStrictFloating = (value, allowEmpty = false) => {
                const valid = check(value, 'floating', allowEmpty);
                return valid || 'message.pleaseEnterValidNumber';
            }
            this.isPhoneNumber = (value, allowEmpty = false) => {
                const valid = check(value, 'phone', allowEmpty);
                return valid || 'message.pleaseEnterValidPhone';
            }
            this.isEmail = (value, allowEmpty = false) => {
                const valid = check(value, 'email', allowEmpty);
                return valid || 'message.pleaseEnterValidEmail';
            }
            this.isValidDate = (value, allowEmpty = false) => {
                if (!Validate.DataValid(value)) {
                    return allowEmpty || 'message.formRequired';
                }

                return this.regexDateStr(value) || 'message.pleaseEnterValidDate';
            }
            this.isValidTime = (value, allowEmpty = false) => {
                if (!Validate.DataValid(value)) {
                    return allowEmpty || 'message.formRequired';
                }

                if (regex.time.test(value)) {
                    const parts = value.split(':');
                    const hour = parseInt(parts[0]);
                    if (hour >= 0 && hour <= 24) {
                        if (parts.length > 1) {
                            const minute = parseInt(parts[1]);
                            if (minute >= 0 && minute <= 59) {
                                if (parts.length > 2) {
                                    const second = parseInt(parts[2]);
                                    if (second >= 0 && second <= 59) {
                                        return true
                                    }
                                } else {
                                    return true
                                }
                            }
                        }
                    }
                }

                return 'message.pleaseEnterValidTime';
            }
            this.isEngName = (value, allowEmpty = false) => {
                const valid = check(value, 'engName', allowEmpty);
                return valid || 'message.pleaseEnterValidEngName';
            }
            this.isValidPassword = (value, allowEmpty = false) => {
                const valid = check(value, '', allowEmpty);
                return valid;
            }
            this.isValidHKId = (value, allowEmpty = false) => {
                if (!Validate.DataValid(value)) {
                    return allowEmpty || 'message.formRequired';
                }

                const hkid4Letter1 = /^[a-zA-Z]{1}[0-9]{3}$/;
                const hkid4Letter2 = /^[a-zA-Z]{2}[0-9]{2}$/;
                const hkid4Letter3 = /^[0-9]{4}$/;

                return hkid4Letter1.test(value) || hkid4Letter2.test(value) || hkid4Letter3.test(value) || 'message.pleaseEnterValidHKID4Letters';
            }

            this.validateFileInput = (file, requiredExtension, isVimeo = false) => {
                // requiredType = img, video...
                // requiredExtension = png, jpg, mp4...

                let result = null
                if (!file) {
                    result = { message: 'message.fileNotFound' };
                } else {
                    const format = file.type.split('/')[1];
                    let limitFileSize = 1024 * 1024 * 10; // bytes (10MB) 
                    if (['mp4', 'webm'].includes(format)) {
                        limitFileSize = 1024 * 1024 * 100; // video max 100MB

                        if (isVimeo) {
                            limitFileSize = 1024 * 1024 * 400; // vimeo video max 400MB
                        }
                    }

                    if (!requiredExtension.includes('*') && !requiredExtension.includes(format)) {
                        result = { message: 'message.fileFormatNotSupport' }
                    } else if (file.size > limitFileSize) {
                        result = {
                            message: 'message.fileSizeLimit',
                            value: {
                                max: limitFileSize / 1024 / 1024
                            }
                        }
                    }
                }

                return result
            }

            this.allowAction = (name, userType) => {
                let checkList = cannotAccessList[`${name}_${option.config.VUE_APP_RUN_MODE}`];
                if (checkList === undefined) {
                    checkList = cannotAccessList[name];
                }
                if (
                    !userType ||
                    (checkList && checkList.length && checkList.includes(userType))
                ) {
                    return false;
                }

                return true;
            }

            this.isDateLess = (d1, d2) => {
                if (d1.getFullYear() < d2.getFullYear()) {
                    return true
                } else if (d1.getFullYear() === d2.getFullYear()) {
                    if (d1.getMonth() < d2.getMonth()) {
                        return true
                    } else if (d1.getMonth() === d2.getMonth()) {
                        if (d1.getDate() < d2.getDate()) {
                            return true
                        }
                    }
                }

                return false
            }
            this.isDateGreater = (d1, d2) => {
                if (d1.getFullYear() > d2.getFullYear()) {
                    return true
                } else if (d1.getFullYear() === d2.getFullYear()) {
                    if (d1.getMonth() > d2.getMonth()) {
                        return true
                    } else if (d1.getMonth() === d2.getMonth()) {
                        if (d1.getDate() > d2.getDate()) {
                            return true
                        }
                    }
                }

                return false
            }
            this.isDateEqual = (d1, d2) => {
                return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate()
            }
            this.isTimeLess = (d1, d2) => {
                if (d1.getHours() < d2.getHours()) {
                    return true
                } else if (d1.getHours() === d2.getHours()) {
                    if (d1.getMinutes() < d2.getMinutes()) {
                        return true
                    }
                }

                return false
            }
            this.isTimeGreater = (d1, d2) => {
                if (d1.getHours() > d2.getHours()) {
                    return true
                } else if (d1.getHours() === d2.getHours()) {
                    if (d1.getMinutes() > d2.getMinutes()) {
                        return true
                    }
                }

                return false
            }
            this.isTimeEqual = (d1, d2) => {
                return d1.getHours() === d2.getHours() && d1.getMinutes() === d2.getMinutes()
            }
        })()
    }
}